import React from 'react'
import { useTranslation } from 'react-i18next'
import { BsChevronLeft } from 'react-icons/bs'
import { useNavigate } from 'react-router-dom'
import { Anchor, Group, Text, Title } from '@mantine/core'

interface IProps {
  back?: boolean
  onBack?: () => void
  title?: React.ReactNode
  rightSection?: React.ReactNode
}

export const PageHeader = ({ back, onBack, title, rightSection }: IProps) => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const handleBack = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault()

    if (onBack) {
      onBack()
    } else {
      navigate(-1)
    }
  }

  const renderTitle = () => {
    if (typeof title === 'string') {
      return <Title order={4}>{title}</Title>
    }

    return title
  }

  return (
    <div className={'flex mb-4 items-center justify-between'}>
      <div className={'flex'}>
        {back && (
          <Anchor component={'a'} onClick={handleBack} color={'dark'}>
            <Group spacing={'xs'}>
              <BsChevronLeft size={24} />

              <Text size={'lg'} weight={700}>
                {t('back')}
              </Text>
            </Group>
          </Anchor>
        )}

        {title && renderTitle()}
      </div>

      {rightSection && <div>{rightSection}</div>}
    </div>
  )
}
